import { Component, Input } from "@angular/core";
import { CandidateMeetingModel, InterviewDashboardResult } from "../../../interviews.models";
import { InterviewType } from "../../../interviews.enums";

@Component({
    selector: 'interview-location-widget',
    templateUrl: './interview-location-widget.component.html',
    standalone: false
})
export class InterviewLocationWidgetComponent {
  @Input() meeting?: CandidateMeetingModel;
  @Input() PhoneCallAltText: boolean = false;
  @Input() dashboardInfo: InterviewDashboardResult | null = null;

  public InterviewType = InterviewType;

  public formatAddress(address: string, postcode: string): string  {
    if(!postcode) {
      return address;
    }
    return address + ' ' + postcode;
  }
}
